import { isFullyMatchedPath, strictRootSearchSchema } from "@blockdaemon/widget-host";
import { useDevToolsEnabled } from "@blockdaemon/widget-host/devtools";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

import { TokenizationWalletProvider } from "../features/wallet/components/tokenization-wallet-provider";
import { useResolvedWalletProviderMode } from "../features/wallet/hooks/use-resolved-wallet-provider-mode";
import { TokenizationDevTools } from "../shared/components/tokenization-dev-tools";
import { TokenizationWidgetLayout } from "../shared/components/tokenization-widget-layout";

export const Route = createFileRoute("/_layout")({
  component: LayoutComponent,
  beforeLoad: ({ location, matches }) => {
    if (isFullyMatchedPath(location.pathname, matches)) {
      const rawSearch = location.searchStr;
      const strictSearchResult = strictRootSearchSchema.safeParse(
        Object.fromEntries(new URLSearchParams(rawSearch)),
      );

      if (!strictSearchResult.success) {
        throw strictSearchResult.error;
      }
    }
  },
});

function LayoutComponent() {
  const location = useLocation();
  const devToolsEnabled = useDevToolsEnabled();
  const walletMode = useResolvedWalletProviderMode();
  const showDevTools = devToolsEnabled && walletMode !== "external";

  if (location.pathname === "/") {
    return <Outlet />;
  }

  return (
    <TokenizationWalletProvider>
      <TokenizationWidgetLayout showWallet>
        <Outlet />
      </TokenizationWidgetLayout>
      {showDevTools ? <TokenizationDevTools /> : null}
    </TokenizationWalletProvider>
  );
}
